var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-auto copyright text-center text-muted h5 text-black"},[_vm._v(" © "+_vm._s(_vm.year)+" YOUR INSURANCE PTY LTD | ABN: 85 650 930 733 ")])}
var staticRenderFns = []

export { render, staticRenderFns }